import { organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

/**
 * In development VITE_API_URL is empty and the Vite proxy forwards /api to the
 * API, keeping the session cookie same-origin. In production it points at
 * api.seoplum.com and the cookie is shared across the .seoplum.com subdomains.
 */
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || window.location.origin,
  basePath: '/api/auth',
  plugins: [organizationClient()],
  fetchOptions: { credentials: 'include' },
})

export const { signIn, signUp, signOut, useSession, organization } = authClient
